export const imageFormat = {
  png: "png",
  jpeg: "jpeg",
  gif: "gif",
};
const CustomImage = ({
  src,
  alt,
  className,
  isBase64 = false,
  format = imageFormat.png,
}) => {
  return (
    <img
      src={isBase64 === true ? `data:image/${format};base64,${src}` : src}
      alt={alt}
      className={className}
    />
  );
};

export default CustomImage;
